import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 49614 49614"
    {...props}
  >
    <path
      d="m41666 23141-16906 1667 15720-7243 9016 392-7830 5184zm1417 19622-4120-7914-14203-10043 9838 13728 8485 4229zm6531-11544-7568-4819-17285-1594 15430 6990 9423-577zM31219 0l-4879 7661-1580 17147 7028-15515L31219 0zM17956 117l-394 9066 7198 15625-1669-16935-5135-7756zm24807 6412-8039 4187-9964 14090 13836-9916 4167-8361zM31656 49496l386-8881-7282-15809 1653 16769 5243 7921zM117 31656l8929 390 15713-7238-16797 1655-7845 5193zm24643-6848-9890-13800-8341-4158 4176 8018 14055 9940zM0 18394l7584 4830 17177 1584-15418-6986L0 18394zm18394 31220 4770-7491 1596-17317-6947 15334 581 9474zM6850 43084l7893-4110 10017-14166-13692 9811-4218 8465z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
